<form [formGroup]="formGroup" *ngIf="!gesendet" class="tab-content">
    <px-error-box #fehlerboxComponent></px-error-box>

    <fieldset class="ba-layout-tile">
        <div class="pflichtfeld">* Pflichtfeld</div>

        <div class="row ba-form-row">
            <div class="col-lg-6">
                <div class="row">
                    <div class="col-xs-12 ba-with-help">
                        <h2 id="ea_falldatenHeader_txt">Falldaten</h2>
                    </div>

                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                        <px-input
                            id="ea_kindergeldnummer"
                            formControlName="kindergeldnummer"
                            placeholder="xxxFKxxxxxx"
                            maxLength="11"
                            >Kindergeldnummer
                            <button
                                pxTooltip="help"
                                trigger="click"
                                title="Kindergeldnummer"
                                content="Die Kindergeldnummer besteht aus insgesamt 11 Zeichen. Die Kindergeldnummer ist wie folgt aufgebaut: &Prime;xxxFKxxxxxx&Prime;. Bitte beachten Sie, dass das &Prime;x&Prime; durch jeweils eine Ziffer zu ersetzen ist."
                            ></button>
                        </px-input>
                    </div>

                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                        <px-input
                            id="ea_zahlstellennummer"
                            formControlName="ordnungkriterium"
                            placeholder="z. B. Personalnummer"
                            maxLength="30"
                            trimInput
                            >Ordnungskriterium des Arbeitgebers
                            <button
                                id="ea_zahlstellennummer-help"
                                type="button"
                                pxTooltip="help"
                                trigger="click"
                                title="Ordnungskriterium des Arbeitgebers"
                                content="Das Ordnungskriterium ist das von Ihnen vergebene Merkmal zur Identifikation Ihres Beschäftigten, welches Sie der Familienkasse übermittelt haben. Zum Beispiel die Personalnummer."
                            ></button>
                        </px-input>
                    </div>
                </div>
            </div>

            <div class="col-lg-4">
                <div class="row">
                    <div class="col-xs-12 ba-with-help">
                        <h2 id="ea_abfragezeitraumHeader_txt">Abfragezeitraum</h2>
                        <button
                            id="ea_abfragezeitraum_help"
                            type="button"
                            pxTooltip="help"
                            trigger="click"
                            title="Abfragezeitraum"
                            content="Eine Auskunft über einen bestehenden Kindergeldanspruch für den aktuellen Monat ist erst nach erfolgter Auszahlung möglich."
                        ></button>
                    </div>

                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                        <px-date
                            id="ea_zeitraumVon"
                            ariaLabel="Anfang des Abfragezeitraums"
                            title="Anfang des Abfragezeitraums"
                            formControlName="zeitraumVon"
                            placeholder="MM.JJJJ"
                            >Anfang
                        </px-date>
                    </div>

                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                        <px-date
                            id="ea_zeitraumBis"
                            title="Ende des Abfragezeitraums"
                            ariaLabel="Ende des Abfragezeitraums"
                            formControlName="zeitraumBis"
                            placeholder="MM.JJJJ"
                            >Ende
                        </px-date>
                    </div>
                </div>
            </div>
        </div>

        <odbs-kind [formGroup]="formGroup"></odbs-kind>

        <div class="d-flex flex-column flex-sm-row justify-content-between">
            <px-button buttonStyleType="secondary" id="ea_formularLeeren" (buttonClicked)="formularLeeren()"
                >Formular leeren
            </px-button>
            <px-button id="ea_absenden" (buttonClicked)="absenden()">Anfrage absenden </px-button>
        </div>
    </fieldset>
</form>

<div *ngIf="gesendet" class="tab-content ba-bg-bright">
    <app-einzelabfrage-ergebnis (neueAnfrage)="neueAnfrage()"></app-einzelabfrage-ergebnis>
</div>
